import {useDebugValue} from 'react';

import {useOptions} from './';

const defaultFormOptions = {
    allowErrorHighlighting: false,
    allowSummary: false,
    autoProgress: true,
    autoSubmit: true,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showGuestsDetailsInputField: true,
    showSubmitDetailsButtonField: true
};

function useFormOptions(props) {
    const {
        formOptions: propsFormOptions
    } = props;

    const {
        options: formOptions
    } = useOptions(defaultFormOptions, propsFormOptions);

    const result = {
        formOptions
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
